var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconUncompleted(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 6,
    viewBox: "0 0 16 6",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 1.36193C0 1.00072 0.139713 0.654312 0.388403 0.398901C0.637093 0.143489 0.974389 0 1.32609 0H14.587C14.9387 0 15.276 0.143489 15.5247 0.398901C15.7734 0.654312 15.9131 1.00072 15.9131 1.36193V4.08579C15.9131 4.447 15.7734 4.79341 15.5247 5.04882C15.276 5.30423 14.9387 5.44772 14.587 5.44772H1.32609C0.974389 5.44772 0.637093 5.30423 0.388403 5.04882C0.139713 4.79341 0 4.447 0 4.08579V1.36193Z",
    fill: "#B6D1FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconUncompleted);
export default __webpack_public_path__ + "static/media/icon-uncompleted.134cc61e952f4cc3d5aaef219da56c1e.svg";
export { ForwardRef as ReactComponent };